import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "errorDisplay"];

  inputTarget!: HTMLInputElement;
  errorDisplayTarget!: HTMLElement;

  connect() {
    console.log("Search controller connected");
  }

  async search(event: Event) {
    event.preventDefault();
    const query = this.inputTarget.value.trim();

    this.errorDisplayTarget.textContent = "";

    try {
      const csrfToken = (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement).content;

      const response = await fetch("/patients/find_or_create_by_cpr", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken || ""
        },
        body: JSON.stringify({ cpr: query })
      });

      const data = await response.json();

      if (data.redirect_url) {
        window.location.href = data.redirect_url;
      } else {
        this.errorDisplayTarget.textContent = data.error;
      }
    } catch (error) {
      console.error("Error during search request:", error);
      this.errorDisplayTarget.textContent = "Kunne ikke finde en person med dette CPR-nummer.";
    }
  }
}
